import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import history from "./utils/history";
import Navigation from "./components/Navigation";
import appRoutes from "./components/Navigation/appRoutes";
import Users from "./components/users/Users";
import ManageUser from "./components/users/ManageUser";
import Agents from "./components/agents/Agents";
import AppWrapper from "carbon-react/lib/components/app-wrapper";
import AuditLogs from "./components/auditLogs/AuditLogs";
import NotFoundBanner from "./components/common/banner/NotFoundBanner";
import ErrorBanner from "./components/common/banner/ErrorBanner";
import UnauthorisedBanner from "./components/common/banner/UnauthorisedBanner";
import LoggedOutBanner from "./components/common/banner/LoggedOutBanner";

import PrivateRoute from "./components/PrivateRoute";

import { AppContextProvider } from "./contexts/AppContext";
import { AgentApiProvider } from "./services/AgentApi";
import { UserApiProvider } from "./services/UserApi";
import { AuditApiProvider } from "./services/AuditApi";
import i18n from "i18n-js";
import { LocalizationContextProvider } from "./contexts/localization/Localization";

import "./App.css";
import "carbon-react/lib/utils/css";

const ManageUserComponentWithApiProvider = () => {
  return (
    <UserApiProvider>
      <AuditApiProvider>
        <ManageUser />
      </AuditApiProvider>
    </UserApiProvider>
  );
};

const UsersComponentWithApiProvider = () => {
  return (
    <UserApiProvider>
      <Users />
    </UserApiProvider>
  );
};

const AuditLogsComponentWithApiProvider = () => {
  return (
    <AuditApiProvider>
      <AuditLogs />
    </AuditApiProvider>
  );
};

const IndexComponent = () => {
  return <Redirect to={appRoutes.users} />;
};

function App() {
  return (
    <div className="App">
      <AgentApiProvider>
        <LocalizationContextProvider i18n={i18n}>
          <AppContextProvider history={history}>
            <Router history={history}>
              <Navigation />
              <AppWrapper id="app-container">
                <Switch>
                  <PrivateRoute exact path="/" component={IndexComponent} />
                  <PrivateRoute
                    path={appRoutes.users}
                    component={UsersComponentWithApiProvider}
                  />
                  <PrivateRoute
                    path={`${appRoutes.user}/:id`}
                    component={ManageUserComponentWithApiProvider}
                  />
                  <PrivateRoute path={appRoutes.agents} component={Agents} />
                  <PrivateRoute
                    path={appRoutes.audit}
                    component={AuditLogsComponentWithApiProvider}
                  />
                  <Route path={appRoutes.notFound} component={NotFoundBanner} />
                  <Route path={appRoutes.error} component={ErrorBanner} />
                  <Route
                    path={appRoutes.loggedOut}
                    component={LoggedOutBanner}
                  />
                  <Route
                    path={appRoutes.unauthorised}
                    component={UnauthorisedBanner}
                  />
                  <Redirect to={appRoutes.notFound} />
                </Switch>
              </AppWrapper>
            </Router>
          </AppContextProvider>
        </LocalizationContextProvider>
      </AgentApiProvider>
    </div>
  );
}

export default App;
